import { render, staticRenderFns } from "./direct-debit-files-tabs.vue?vue&type=template&id=1b01b0e2&scoped=true&"
import script from "./direct-debit-files-tabs.ts?vue&type=script&lang=ts&"
export * from "./direct-debit-files-tabs.ts?vue&type=script&lang=ts&"
import style0 from "./direct-debit-files-tabs.scss?vue&type=style&index=0&id=1b01b0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01b0e2",
  null
  
)

export default component.exports